import forgotPassword from './forgotPassword'
import resetPassword from './resetPassword'

export default { forgotPassword, resetPassword }
